export default class {
  constructor(elms) {
    this.dom = { elms };
    this.io = null;
    this.SHOW_THRESHOLD = 0.25; // 要素が70%表示された時にアニメーション開始
    
    this.checkScroll = this.checkScroll.bind(this);
    this.init();
  }

  init() {
    const ioOptions = {
      threshold: this.SHOW_THRESHOLD,
    };
    
    this.io = new IntersectionObserver(this.checkScroll, ioOptions);
    
    // 各要素を監視対象に追加
    [...this.dom.elms].forEach(el => {
      this.io.observe(el);
    });
  }

  checkScroll(entries) {
    entries.forEach(entry => {
      // 要素が70%以上表示された場合にshow状態にする
      if (entry.intersectionRatio >= this.SHOW_THRESHOLD) {
        entry.target.dataset.is = 'show';
      }
    });
  }
}
